import { FallbackProps } from 'react-error-boundary';
import React from 'react';

const FallbackComponent = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <div>
      <div>
        <div>ERROR: {error?.message}</div>
      </div>
      <div>
        <button onClick={resetErrorBoundary}>RESET</button>
      </div>
    </div>
  );
};

export default FallbackComponent;
